module.exports = __webpack_public_path__ + "img/bg-login.af353e3b.jpg";